// wifi signal strength directive
//
//   <wifi-signal-strength pct="0.5" label-position="'left'" />
//

let module = angular.module('app.directives');

module.directive('wifiSignalStrength', () => {
  return {
    restrict: 'E',
    scope: { pct: '=pct', labelPosition: '=labelPosition' },
    template: `
      <div style="position:relative;text-align:center;top:5px;">
        <span class="hidden-xs" style="position:relative;top:-5px;" ng-if="labelPosition == 'left'">{{(pct * 100) | number:0}}%</span>
        <div style="display:inline-block;" class="wifi-icon {{suppClass}}"></div>
        <span class="hidden-xs" style="position:relative;top:-5px;" ng-if="labelPosition == 'right'">{{(pct * 100) | number:0}}%</span>
      </div>
    `,
    link: (scope) => {
      // 4 bars: 0-9%=0 bars, 10-19%=0 bars, 20-39=2 bars, 40-59%=3 bars, ...
      if (scope.pct < 0.25) {
        scope.suppClass = 'none';
      } else if (scope.pct < 0.5) {
        scope.suppClass = 'weak';
      } else if (scope.pct < 0.75) {
        scope.suppClass = 'medium';
      } else {
        scope.suppClass = '';
      }
    },
  };
});



// WEBPACK FOOTER //
// ./app/directives/wifi-signal-strength.js